/**
 * 模組代碼 : -
 * 模組說明 : (共用模組) 提供共用功能元件及函式
 * @module web/components/CommonComponent
 */

// ----- import from npm modules -----
import $ from 'jquery';
import 'datatables.net-bs5'; // 引入 DataTables Bootstrap 5 样式
import DataTable from 'datatables.net-dt';

// ----- constants -----
const PAGE_LENGTH = 20;

$.fn.dataTable.ext.oSort['natural-asc'] = function (a, b) {
    //console.log('Sorting ASC:', a, b); // 用於檢查排序過程

    // 將 a 和 b 轉換為字串，並移除 <i> 標籤及其內容
    a = a.toString().replace(/<i.*?>.*?<\/i>/g, '').replace('樓', '');
    b = b.toString().replace(/<i.*?>.*?<\/i>/g, '').replace('樓', '');

    // 如果兩個都是純數字，直接進行數字比較（升序）
    if (/^\d+$/.test(a) && /^\d+$/.test(b)) {
        return parseInt(a, 10) - parseInt(b, 10);
    }

    // 如果兩者都是字母加數字組合，則按字母降序比較
    if (/^[a-zA-Z]+\d+$/.test(a) && /^[a-zA-Z]+\d+$/.test(b)) {
        const aLetter = a.match(/[a-zA-Z]+/)[0];
        const bLetter = b.match(/[a-zA-Z]+/)[0];

        // 字母部分按降序排列
        if (a < b) return 1;
        if (a > b) return -1;
        if (aLetter < bLetter) return 1;
        if (aLetter > bLetter) return -1;

        // 如果字母部分相同，則比較數字部分，按升序排列
        const aNumber = parseInt(a.match(/\d+/)[0], 10);
        const bNumber = parseInt(b.match(/\d+/)[0], 10);
        return aNumber - bNumber;
    }

    // 如果一個是純數字，另一個是字母加數字組合，字母加數字組合優先
    if (/^\d+$/.test(a) && /^[a-zA-Z]+\d+$/.test(b)) return 1;
    if (/^[a-zA-Z]+\d+$/.test(a) && /^\d+$/.test(b)) return -1;

    // 其餘情況按字串進行比較
    return a.localeCompare(b);
};



$.fn.dataTable.ext.oSort['natural-desc'] = function (a, b) {
    //console.log('Sorting DESC:', a, b); // 用於檢查排序過程

    // 將 a 和 b 轉換為字串
    a = a.toString().replace(/<i.*?>.*?<\/i>/g, '').replace('樓', '');
    b = b.toString().replace(/<i.*?>.*?<\/i>/g, '').replace('樓', '');

    // 檢查 a 和 b 是否是純數字
    const aIsNumber = /^\d+$/.test(a);
    const bIsNumber = /^\d+$/.test(b);

    // 如果兩者都是數字，則按數字進行降序排序
    if (aIsNumber && bIsNumber) {
        return parseInt(b, 10) - parseInt(a, 10); // 確保數字部分降序排列
    }

    // 如果只有一個是數字，讓數字優先排在前面
    if (aIsNumber) return -1; // a 是數字，排在前面
    if (bIsNumber) return 1;  // b 是數字，排在前面

    // 將非純數字部分按 ASCII 值降序比較
    if (a < b) return -1;   // 保持 ASCII 升序
    if (a > b) return 1;    // 保持 ASCII 升序

    return 0; // 如果完全相同，返回 0
};


/**
 * 說明：透過 DataTables 套件，將資料以表格方式呈現
 * @param {*} tableSelector 
 * @param {*} dataSet 
 * @param {*} columnConfig 
 * @param {*} orderConfig 
 * @param {*} fixedColumnsConfig 
 */
export function DataTableComponent(tableSelector, dataSet, columnConfig, orderConfig, fixedColumnsConfig, bPaginate = false, bScrollX = false) {
    /** Only for debug
    console.log('DataTableComponent is being rendered with the following props:');
    console.log('dataSet:', dataSet);
    console.log('columnConfig:', columnConfig);
    console.log('orderConfig:', orderConfig);
    console.log('fixedColumnsConfig:', fixedColumnsConfig);
    */

    return new DataTable(tableSelector, {
        retrieve: true,
        language: {
            info: '共 _TOTAL_ 筆資料',
            infoEmpty: '沒有資料',
            lengthMenu: '每頁顯示 _MENU_ 筆資料',
            zeroRecords: '找不到資料',
        },
        dom: 'rt<"dt-bottom" <"dt-info"i><"dt-paging"p>>',
        searching: false,
        lengthMenu: [20, 50, 100],
        select: true,
        paging: bPaginate,
        pageLength: PAGE_LENGTH,
        responsive: true,
        scrollCollapse: true,
        scrollY: '45vh',
        scrollX: bScrollX, // Enable horizontal scrolling
        fixedColumns: fixedColumnsConfig,
        columns: columnConfig,
        data: dataSet,
        order: orderConfig,
        // 使用 Bootstrap 5 样式
        className: 'dt-bootstrap5'
    });
};

/**
 * 說明：批次控制功能
 */
export function batchCheckControls() {
    // Function to update the indeterminate state of the #check-all checkbox and the button state
    function updateCheckAllAndButtonState() {
        var allCheckboxes = $('input[name="cks"]')
        var checkedCheckboxes = allCheckboxes.filter(':checked')

        // Update #check-all checkbox state
        var totalCheckboxes = allCheckboxes.length
        var totalChecked = checkedCheckboxes.length

        if (totalChecked === 0) {
            $('#check-all').prop('checked', false)
            $('#check-all').prop('indeterminate', false)
        } else if (totalChecked === totalCheckboxes) {
            $('#check-all').prop('checked', true)
            $('#check-all').prop('indeterminate', false)
        } else {
            $('#check-all').prop('checked', false)
            $('#check-all').prop('indeterminate', true)
        }

        // Enable/disable buttons based on checkbox state
        $('.btn-batch').prop('disabled', totalChecked === 0)

        // Update checked count display
        $('#checked-count-display').text('( ' + totalChecked + ' )')
    }

    // Event listener for the #check-all checkbox
    $('#check-all').on('change', function () {
        var isChecked = $(this).is(':checked')
        $('input[name="cks"]').prop('checked', isChecked)
        updateCheckAllAndButtonState()
    })

    // Event listener for individual checkboxes with name="cks"
    $(document).on('change', 'input[name="cks"]', function () {
        updateCheckAllAndButtonState()
    })

    // Initial state update when the page loads
    updateCheckAllAndButtonState()
}